var map = {
	"./SETTAMA - 1.jpg": 69806,
	"./SETTAMA - 2.jpg": 88829,
	"./SETTAMA - 3.jpg": 78219,
	"./SETTAMA - 4.jpg": 37416,
	"./document thumbnail/thumb-1.png": 33273,
	"./document thumbnail/thumb-2.png": 1361,
	"./document/contoh nomor 1.pdf": 92454,
	"./document/sample2.pdf": 15089,
	"./document/sample3 long long name document.pdf": 28912,
	"./video thumbnail/VideoThumbnail1.png": 69211,
	"./video thumbnail/VideoThumbnail2.png": 65161,
	"./video thumbnail/dummy.txt": 73990,
	"./video/dummy.txt": 13317
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 74936;